import dayjs from "dayjs";

export const compose = (...params) => params.reduce((prev, next) => (acc) => next(prev(acc)));

export const chileCurrency = (curr) => {
  return '$ ' + new Intl.NumberFormat('de-DE').format(curr);
  //Intl.NumberFormat('de-DE', {style: "currency", currency: "CLP"}).format(curr)
};

export const capitalize = (string) => {
  return string ? `${string[0].toUpperCase()}${string.slice(1)}` : string;
};

export const emptyFn = () => {
};

export const showFile = (function () {
  return function (blob) {
    const newBlob = new Blob([blob], {type: 'application/pdf'})

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob)
      return
    }

    const data = window.URL.createObjectURL(newBlob);
    const link = document.createElement('a');
    link.href = data;
    link.href = data;
    link.target = '_blank';
    link.click();

    // document.body.removeChild(link);
    window.open(data);

    setTimeout(function () {
      window.URL.revokeObjectURL(data)
    }, 100)
  }
}())

export const id = () => {
  return '_' + Math.random().toString(36).substr(2, 9);
};

export const debounce = (func, wait, immediate) => {
  let timeout;
  return function () {
    const context = this, args = arguments;
    const later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

export const pick = (obj = {}, keys = []) => {
  if (keys.length === 0) return obj;

  const data = {};

  keys.forEach(key => {
    data[key] = obj[key];
  });

  return data
};

export const omit = (obj = {}, keys = []) => {
  if (keys.length === 0) return obj;

  return Object.keys(obj).reduce((acc, key) => {
    if (!keys.includes(key)) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

export const formatDate = (date, format) => {
  if (!date) return '';
  return dayjs(date).format(format);
}

export const handlePreview = (url) => {
  window.open(url, '_blank');
};

export const formatCurrency = (value) => value && `$ ${new Intl.NumberFormat('de-DE').format(value)}`;
